import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { NEWSBOARD_POST_FORM_FIELD_NAME_RECIPIENT } from '../../NewsboardPostForm.constants'

import { CustomizeRecipientAudienceField } from './CustomizeRecipientAudienceField'
import { NEWSBOARD_POST_FORM_RECIPIENTS_INITIAL_VALUES } from './RecipientsField.constants'

import * as styles from './RecipientsField.module.css'

function RecipientsField({ recipientInitialValues, ticker, ...restProps }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const previousTicker = useRef(ticker)

  const [initialValues, setInitialValues] = useState(
    () =>
      recipientInitialValues ?? NEWSBOARD_POST_FORM_RECIPIENTS_INITIAL_VALUES
  )

  useEffect(() => {
    if (previousTicker.current !== ticker) {
      setInitialValues(NEWSBOARD_POST_FORM_RECIPIENTS_INITIAL_VALUES)
      previousTicker.current = ticker
    }
  }, [ticker])

  return (
    <FormikField
      {...restProps}
      Component={CustomizeRecipientAudienceField}
      controlProps={{
        borderless: !isMobileScreenSize,
      }}
      fieldComponentProps={{
        fieldInputClassName: styles.field,
        label: `${t('Newsboard.RecipientsLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      initialValues={initialValues}
      name={NEWSBOARD_POST_FORM_FIELD_NAME_RECIPIENT}
      setInitialValues={setInitialValues}
      ticker={ticker}
    />
  )
}

export default RecipientsField
